export default "__VITE_ASSET__BNtKeV75__"